function navSlideout(){
  const navBodyLock = document.querySelector('body');
  const navMain = document.querySelector('.header__slideout-navigation');
  const navButtons = document.querySelectorAll('.main-slideout-menu-button');
  const navLinkedButton = document.querySelectorAll('.main-slideout-linked-button');
  const navPanelContainer = document.querySelector('.main-slideout-container');
  const navPanel = document.querySelector('.main-slideout-panel');
  const navPanelClose = document.querySelector('.main-slide-panel-close');
  const navPanelOverlay = document.querySelector('.main-slideout-panel-overlay');
  const navPanelInnerMain = document.querySelectorAll('.slide-sub-panel');
  const navPanelInnerParent = document.querySelectorAll('.main-slideout-parent-button');
  const navPanelHidden = document.querySelectorAll('#enable-ada-cx-widget, #ada-button-frame, #ada-chat-button, #back-to-top-link');
  navMain.classList.remove('hidden'); 

  // Active Panels
  function navInnerActivePanels() {
    document.querySelectorAll('.sub-inner-child-panel, .sub-inner-grandchild-panel').forEach(panel => {
      if(panel.classList.contains('active')){
        panel.classList.remove('active');
      }
    });
  } 

  // Check if Match
  const navActiveButtons = document.querySelectorAll('.main-slideout-menu-button[data-target]');
  navActiveButtons.forEach(button => {
      const targetId = button.dataset.target;
      const matchingDiv = document.querySelector(`div[data-id="${targetId}"]`);
      if (matchingDiv) {
        button.classList.add('sub-panel-enabled');
      } else {
        button.classList.remove('sub-panel-enabled');
      }
  });

  // Main-Menu
  navButtons.forEach(button => {
    button.addEventListener('click', () => {
      navButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      const targetNum = button.getAttribute('data-target');
      document.querySelectorAll('.main-slideout-inner-panel').forEach(div => {
        div.classList.remove('active');
      });
      const targetDiv = document.querySelector(`.main-slideout-inner-panel[data-id="${targetNum}"]`);
      if (targetDiv) {
        navBodyLock.classList.add('overflow-hidden');
        targetDiv.classList.add('active');
        navPanelContainer.classList.add('active');
        navPanel.classList.add('active');
        navPanelOverlay.classList.add('active');
      }
      navMain.classList.add('open');
      document.querySelectorAll('.main-slideout-parent-button').forEach(parentButton => {
        parentButton.classList.remove('open');
      });
      navInnerActivePanels();
    });
  });

  // Sub-Menus
  const setupToggleNavigation = (btnSelector, panelSelector, extraPanelsToClose = null) => {
    const buttons = document.querySelectorAll(btnSelector);
    const panels = document.querySelectorAll(panelSelector);
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-target');
        const targetPanel = document.querySelector(`${panelSelector}[data-id="${targetId}"]`);
        if (!targetPanel) return;
        const isAlreadyOpen = button.classList.contains('open');
        panels.forEach(p => p.classList.remove('active'));
        buttons.forEach(b => b.classList.remove('open'));
        if (extraPanelsToClose) {
          document.querySelectorAll(extraPanelsToClose).forEach(p => p.classList.remove('active'));
        }
        if (!isAlreadyOpen) {
          button.classList.add('open');
          targetPanel.classList.add('active');
        }
      });
    });
  };

  setupToggleNavigation(
    '.main-slideout-parent-button', 
    '.sub-inner-child-panel', 
    '.sub-inner-grandchild-panel'
  );

  setupToggleNavigation(
    '.main-slideout-child-button', 
    '.sub-inner-grandchild-panel'
  );

  navPanelInnerParent.forEach(button => {
      button.addEventListener("click", () => {
        document.querySelectorAll('.main-slideout-child-button').forEach(childButton => childButton.classList.remove('open'));
      });
  });

  navLinkedButton.forEach(link => {
      link.addEventListener("click", () => {
        navBodyLock.classList.remove('overflow-hidden');
        navPanel.classList.remove('active');
        navPanelOverlay.classList.remove('active');
        navMain.classList.remove('open');
        setTimeout(() => {
          navPanelContainer.classList.remove('active');
        }, 500);
        navInnerActivePanels();
      });
  });

  // Panel Close
  navPanelClose.addEventListener("click", function() {
      navBodyLock.classList.remove('overflow-hidden');
      navPanel.classList.remove('active');
      navPanelOverlay.classList.remove('active');
      navMain.classList.remove('open');
      document.querySelectorAll('.main-slideout-menu-button').forEach(menuButton => menuButton.classList.remove('active')); 
      document.querySelectorAll('.main-slideout-parent-button').forEach(parentButton => parentButton.classList.remove('open'));
      setTimeout(() => {
        navPanelContainer.classList.remove('active');
      }, 500);
      navInnerActivePanels();
  });

  // Panel Overlay
  navPanelOverlay.addEventListener("click", function() {
      navBodyLock.classList.remove('overflow-hidden');
      navPanel.classList.remove('active');
      navMain.classList.remove('open');
      document.querySelectorAll('.main-slideout-menu-button').forEach(menuButton => menuButton.classList.remove('active')); 
      document.querySelectorAll('.main-slideout-parent-button').forEach(parentButton => parentButton.classList.remove('open'));
      this.classList.remove('active');
      setTimeout(() => {
        navPanelContainer.classList.remove('active');
      }, 550);
      navInnerActivePanels();
  });
} 

document.addEventListener('DOMContentLoaded', navSlideout);
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === '{{ section.id }}') {
      navSlideout();
    }
  });
}